import { ModalCloseButton } from './ModalCloseButton';
import { ModalContainer } from './ModalContainer';
import { ModalContent } from './ModalContent';
import { ModalHeader } from './ModalHeader';

const ModalPrimitive = {
  Header: ModalHeader,
  CloseButton: ModalCloseButton,
  Content: ModalContent,
  Container: ModalContainer,
};
export { ModalPrimitive };
